<template>
  <div class="page-container">
    <el-card>
      <!-- 搜索区 -->
      <div class="search-bar">
        <el-input
          v-model="query.keyword"
          placeholder="搜索优惠券名称"
          clearable
          style="width: 200px"
          @keyup.enter.native="handleSearch"
        />
        <el-select v-model="query.status" placeholder="状态" clearable style="width: 110px">
          <el-option label="启用" :value="1" />
          <el-option label="禁用" :value="0" />
        </el-select>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <!-- 操作 -->
      <div class="action-bar">
        <el-button
          v-permission="['coupon:create']"
          type="success" size="mini" icon="el-icon-plus"
          @click="$router.push('/coupon/edit')"
        >新增优惠券</el-button>
      </div>

      <!-- 表格 -->
      <el-table :data="tableData" v-loading="loading" border stripe style="width:100%">
        <el-table-column prop="id" label="ID" width="65" align="center" />
        <el-table-column prop="name" label="优惠券名称" min-width="150" show-overflow-tooltip />
        <el-table-column label="立减金额" width="120" align="right">
          <template slot-scope="{ row }">
            <span class="val-price">¥{{ Number(row.amount).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="可用产品" min-width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.product">{{ row.product.name }}</span>
            <span v-else class="text-muted">不限产品</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" min-width="200">
          <template slot-scope="{ row }">
            <span>{{ row.started_at }} ~ {{ row.expired_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="160" />
        <el-table-column label="操作" width="230" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-permission="['coupon:detail']"
              type="info" size="mini" icon="el-icon-view"
              @click="$router.push(`/coupon/detail?id=${row.id}`)"
            >详情</el-button>
            <el-button
              v-permission="['coupon:update']"
              type="primary" size="mini" icon="el-icon-edit"
              @click="$router.push(`/coupon/edit?id=${row.id}`)"
            >编辑</el-button>
            <el-button
              v-permission="['coupon:issue']"
              type="success" size="mini" icon="el-icon-s-promotion"
              @click="$router.push(`/coupon/issue?id=${row.id}`)"
            >发放</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page="query.page"
        :page-sizes="[10, 15, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top:16px;text-align:right"
        @size-change="val => { query.pageSize = val; fetchData() }"
        @current-change="val => { query.page = val; fetchData() }"
      />
    </el-card>
  </div>
</template>

<script>
import { getCouponList } from '@/api/coupon'

export default {
  name: 'CouponManage',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: { page: 1, pageSize: 15, keyword: '', status: '' }
    }
  },
  created() { this.fetchData() },
  activated() { this.fetchData() },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (params.status === '') delete params.status
        const res = await getCouponList(params)
        const d = res.data || {}
        this.tableData = d.data || d.list || []
        this.total = d.total || 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.query.page = 1; this.fetchData() },
    handleReset() {
      this.query = { page: 1, pageSize: 15, keyword: '', status: '' }
      this.fetchData()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; flex-wrap: wrap; }
.action-bar { margin-bottom: 14px; }
.text-muted  { color: #c0c4cc; font-size: 12px; }
.val-price   { color: #f56c6c; font-weight: 600; }
</style>
